import React from 'react';
import dayjs from 'dayjs';

// Material UI
import Typography from '@material-ui/core/Typography';
import ListItem from '@material-ui/core/ListItem';
import Box from '@material-ui/core/Box';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from '@material-ui/core/ListItemText';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';

// Data
import { ageGroupBadgeLabel } from '../../../lib/helpers/age-group.helpers';
import { numToTime } from '../../../lib/helpers/conversion.helpers';
import { useCompanySportTerminology } from '../../../lib/stores/company.store';
import { SportTerminology } from '../../../lib/types';

interface IUpcomingAssessmentSessionItem {
  assessmentSession: IAssessmentSession;
  selectSession: Function;
}

export const UpcomingAssessmentSessionItem: React.FC<IUpcomingAssessmentSessionItem> = ({ assessmentSession, selectSession }) => {
  const termLookup = useCompanySportTerminology();
  const badgeLabel = ageGroupBadgeLabel(assessmentSession.ageGroup);

  return (
    <ListItem button onClick={() => selectSession(assessmentSession)}>
      <Box mr={2}>
        <Avatar style={{ fontSize: '0.875rem', fontWeight: 600 }}>{badgeLabel || undefined}</Avatar>
      </Box>
      <ListItemText
        primary={assessmentSession.location || assessmentSession.address}
        secondary={(
          <>
            {assessmentSession.location && <>{assessmentSession.address}<br /></>}
            {dayjs(assessmentSession.date).format('MMMM Do')} at {numToTime(assessmentSession.start)} for {assessmentSession.duration} minutes
          </>
        )}
      />
      <ListItemSecondaryAction>
        <Typography gutterBottom>{assessmentSession.playerCount} {termLookup[SportTerminology.ATHLETE]}{assessmentSession.playerCount !== 1 && 's'}</Typography>
        <Typography>
          {assessmentSession.drillCount} {termLookup[SportTerminology.EVENT]}{assessmentSession.drillCount !== 1 && 's'}&nbsp;|&nbsp;
          {assessmentSession.practicePlanCount} Practice Plan{assessmentSession.practicePlanCount !== 1 && 's'}
        </Typography>
      </ListItemSecondaryAction>
    </ListItem>
  );
};
